import { render, staticRenderFns } from "./eCommCogsProductTextOnly.vue?vue&type=template&id=10a5681e&scoped=true"
import script from "./eCommCogsProductTextOnly.vue?vue&type=script&lang=js"
export * from "./eCommCogsProductTextOnly.vue?vue&type=script&lang=js"
import style0 from "./eCommCogsProductTextOnly.vue?vue&type=style&index=0&id=10a5681e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a5681e",
  null
  
)

export default component.exports